import { sendPostQuery } from "./helpers";

export const sendEvent = (eventName) => {
    const url = '/button-event';
    const data = {
        'eventName': eventName,
    };
    sendPostQuery(url, false, false, data);
}

window.sendEvent = sendEvent
